<template>
  <div class="contact-us">
    <div class="pc d-none d-lg-block contact-us">
      <div class="container">
        <div class="product-text">
          我们的产品和解决方案
          <br />
          已经为<span class="main-color">数千万计</span>的用户提供服务
        </div>
        <ContactBtn class="btn-box" width="160px" height="64px" fontSize="24px">
          <template v-slot:default> 联系我们 </template>
        </ContactBtn>
      </div>
    </div>
    <div class="mobile d-lg-none contact-us">
      <div class="container">
        <div class="product-text">
          我们的产品和解决方案已经为
          <br />
          <span class="main-color">数千万计</span>的用户提供服务
        </div>
        <ContactBtn class="btn-box" width="100px" height="30px" fontSize="17px">
          <template v-slot:default> 联系我们 </template>
        </ContactBtn>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {};
    },
    created() {},
    mounted() {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .contact-us {
    background: #edfdf8;
  }

  .pc {
    .container {
      padding: 100px 0;

      @extend .flex-space-between;

      .product-text {
        color: #333;
        font-size: 40px;

        span.main-color {
          color: $main-color;
        }
      }
    }
  }

  .mobile {
    .container {
      padding: 50px 0;
      text-align: center;

      .product-text {
        font-size: 18px;
        font-weight: 500;

        span.main-color {
          color: $main-color;
        }
      }
    }

    .btn-box {
      margin-top: 27px;
    }
  }
</style>
